// extracted by mini-css-extract-plugin
export default {"tx":"a74ae21ce2","line":"_050a312197"};